import { useEffect } from 'react'
import PropTypes from 'prop-types'
import './Toast.css'

const Toast = ({ message, type = 'info', duration = 5000, onClose }) => {
  useEffect(() => {
    const timeoutDuration = type === 'error' ? 15000 : duration

    const timer = setTimeout(() => {
      onClose()
    }, timeoutDuration)

    return () => clearTimeout(timer)
  }, [duration, onClose, type])

  return (
    <div className={`toast toast-${type}`}>
      <span>{message}</span>
      <button className='toast-close' onClick={onClose}>
        <i className='bi bi-x' />
      </button>
    </div>
  )
}

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['info', 'success', 'error', 'warning']),
  duration: PropTypes.number,
  onClose: PropTypes.func.isRequired,
}

export default Toast
